import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TitleService } from './../../services/title.service';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found-page.component.html',
  styleUrls: ['./not-found-page.component.scss'],
})
export class NotFoundPage {
  constructor(
    private route: ActivatedRoute,
    private titleService: TitleService
  ) { }

  ngOnInit() {
    const { meta } = this.route.snapshot.data;
    this.titleService.setTitle(meta.title);
  }
}
